import 'reflect-metadata';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import pl from '@angular/common/locales/pl';
import enGB from '@angular/common/locales/en-GB';
import localePlExtra from '@angular/common/locales/extra/pl';
import { AppBootstrap } from '@lib/core';

const CONFIG_REFRESH_INTERVAL = 1 * 60 * 60 * 1000; // 1 hour

AppBootstrap.bootstrap({
  appModule: AppModule,
  environment,
  configRefreshInterval: CONFIG_REFRESH_INTERVAL,
  locales: [
    { data: pl, id: 'pl-PL', extra: localePlExtra },
    { data: enGB, id: 'en-GB' }
  ],
  providers: []
});
